import { TenantOption } from "src/core/types/tenant";

export const buildTenantIdsKey = (tenants: TenantOption[]): string =>
  tenants.map((t) => t.id).join(",");

export const areTenantsSame = (a: TenantOption[], b: TenantOption[]): boolean => {
  if (a.length !== b.length) return false;

  for (let i = 0; i < a.length; i += 1) {
    const ta = a[i];
    const tb = b[i];
    if (!ta || !tb) return false;
    if (ta.id !== tb.id) return false;
    if (ta.name !== tb.name) return false;
  }

  return true;
};
